import React from 'react'
import { Container ,Col, Row } from 'react-bootstrap'
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function IntroMaca() {

    const data = useStaticQuery(graphql`
    query Macademia {
        file(relativePath: {eq: "macademia-green.jpg"}) {
            childImageSharp {
                gatsbyImageData (
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                )
            }
        }
    } 
`);

const macademiaImage = getImage(data.file);

    return (
        <section className="py-5">
            <Container>
                <Row className="g-4">
                    <Col sm={11} md={6} lg={5}>
                        <GatsbyImage 
                            image={macademiaImage} 
                            alt="Green Macademia Nuts" 
                        />
                    </Col>
                    <Col sm={11} md={6} lg={5} xl={5} className="about-intro-info offset-md-1">
                        <h2 className="fs-2 mb-4 fw-bold make-serif topic"><span className="fw-light make-serif">About </span>Macademia Nuts</h2>
                        <p className="secondary-text small-text-02">Macademia is a fast growing medium-sized evergreen tree, and is originally from Australia. The nut has a leathery case one inch in diameter.</p>
                        <p className="secondary-text small-text-02">The case usually contains one or two spherical hard shell casing a white kernel. Highest quality of the Macademia Nuts are not only free of defects or insects and fungal, but also contain at 70% oil.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
